import { getStateSliceFor } from 'redux/Studio';
import { couponBannerReducerKey } from './reducer';

import moment from 'moment';

export const getCurrentDate = moment();
const extractDataFrom = state => getStateSliceFor({
  state,
  reducerKey: couponBannerReducerKey
});

export const getCoupon = state => extractDataFrom(state).coupon;
export const getIsValidCoupon = state => extractDataFrom(state).isValid && moment(getCurrentDate < getExpirationDateEndofDay(state));
export const getCouponCreatedDate = state => getCoupon.createdAt;
export const getCreatedDatePlusTwoWeeks = state => moment(getCouponCreatedDate(state)).add(14, 'days');
export const getExpirationDate = state => moment(getCouponCreatedDate(state)).add(14, 'days').calendar();
export const getExpirationDateEndofDay = state => moment(getCreatedDatePlusTwoWeeks(state)).endOf('day');
export const getExpirationDateTime = state => getExpirationDateEndofDay(state).format('hh:mm a').toUpperCase();
